import { Box } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { updateLoader } from '../../redux/slices/loaderSlice'
import { UserApiResponse } from '../UserManagement/interfaces'
import { UserStatus } from '../../constants/constants'
import { fetchUsers } from '../../services/userServices'
import SearchAndMultiSelectInput from './SearchAndMultiSelectInput'

interface UserTypeAttributeProps {
    label: string
    id: string
    value: any
    onChange: any
    errorMessage?: string
    required?: boolean
    disabled?: boolean
}

const UserTypeAttribute = (props: UserTypeAttributeProps): ReactElement => {
    const { label, id, value, onChange, errorMessage, required, disabled } =
        props

    const org = useAppSelector((state) => state.org.org)

    const dispatch = useAppDispatch()

    const [list, setList] = useState<any[]>([])

    const [selectedValues, setSelectedValues] = useState<string[]>([])

    useEffect(() => {
        if (value) {
            setSelectedValues(value)
        } else {
            setSelectedValues([])
        }
    }, [value])

    useEffect(() => {
        dispatch(updateLoader(true))

        const getRecords = async () => {
            const response = (await fetchUsers({
                pageNumber: 1,
                size: 1000,
                searchText: '',
                filterBy: '',
                sortOrder: '',
                orgId: org!.id,
            })) as UserApiResponse
            const updatedGetUsers =
                response?.usersModels?.filter(
                    (i) => i.status?.toLowerCase() === UserStatus.ACTIVE,
                ) || []
            setList(updatedGetUsers)
        }
        getRecords()

        dispatch(updateLoader(false))
    }, [])

    const onSelectRecord = (id: string, entityIds: any) => {
        onChange(id, entityIds)
    }

    return (
        <Box>
            <SearchAndMultiSelectInput
                label={label}
                id={id}
                value={selectedValues}
                onSelect={onSelectRecord}
                list={list}
                required={required}
                disabled={disabled}
                errorMessage={
                    !selectedValues.length && errorMessage ? errorMessage : ''
                }
            />
        </Box>
    )
}

export default UserTypeAttribute
